import { Chip, Popover, styled } from "@mui/material";

const CHIPBUTTON_PREFIX = "ChipButton";
export const chipButtonClasses = {
  root: `${CHIPBUTTON_PREFIX}-root`,
  chip: `${CHIPBUTTON_PREFIX}-chip`,
  label: `${CHIPBUTTON_PREFIX}-label`,
};

export const ChipButton = styled(Chip)(() => ({
  [`&.${chipButtonClasses.root}`]: {
    width: "fit-content",
    [`& .${chipButtonClasses.label}`]: {
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
}));

const POPOVERDROPDOWN_PREFIX = "PopoverDropdown";
export const popoverDropdownClasses = {
  root: `${POPOVERDROPDOWN_PREFIX}-root`,
  option: `${POPOVERDROPDOWN_PREFIX}-option`,
};

export const PopoverDropdown = styled(Popover)({
  [`&.${popoverDropdownClasses.root}`]: {
    [`& .${popoverDropdownClasses.option}`]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
});
